
import { defineComponent, reactive } from 'vue'
import { createArray } from '@/util'
export default defineComponent({
  name: 'App',
  setup () {
    const blocks = reactive(createArray(6, idx => String.fromCharCode(65 + idx)))
    return {
      blocks
    }
  }
})
